import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import PageAPI from "../../api/PageAPI";
import { newToastEvent } from "../../../utils/ToastUtil";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { useNavigate } from "react-router-dom";

// Redirect - If the page is forbidden, redirect to the home page (Default = true)
const usePage = (pageID: string, redirect: boolean = true) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const navigate = useNavigate();
  const workspaceID = useAtomValue(workspaceIdAtom);
  const tenantID = useAtomValue(tenantIDAtom);

  const page = useQuery({
    queryKey: ["page", pageID],
    queryFn: () =>
      PageAPI.getPageByID(workspaceID, pageID)
        .then((data) => data?.data?.data?.page)
        .catch((err) => {
          if (!redirect) return null;
          const status = err?.response?.status;

          if (status === 403) {
            navigate(
              `/clouds/${tenantID}/workspaces/${workspaceID}/home/pages`
            );

            newToastEvent(
              "error",
              "You do not have permission to view that page."
            );
          }

          if (status === 404) {
            navigate(
              `/clouds/${tenantID}/workspaces/${workspaceID}/home/pages`
            );

            newToastEvent("error", "Page not found.");
          }

          return null;
        }),
    enabled: !!pageID && queriesEnabled,
  });

  return {
    page: page.data,
    pageLoading: page.isLoading || queriesEnabled === false,
    pageError: page.error ? getErrorMessage(page.error) : null,
  };
};

export default usePage;
